export const getEnvironmentEndpoint = (endpoint: string) => {
  const shopName = Shopify.shop;
  if (shopName === 'mister-minit-dev.myshopify.com') {
    return `${endpoint}&environment=staging`;
  } else if (shopName === 'minit-ec.myshopify.com') {
    return `${endpoint}&environment=production`;
  }
  return endpoint;
};
